import { render, staticRenderFns } from "./DevCardKS2.vue?vue&type=template&id=1670457a&scoped=true"
import script from "./DevCardKS2.vue?vue&type=script&lang=js"
export * from "./DevCardKS2.vue?vue&type=script&lang=js"
import style0 from "./DevCardKS2.vue?vue&type=style&index=0&id=1670457a&prod&lang=css"
import style1 from "./DevCardKS2.vue?vue&type=style&index=1&id=1670457a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670457a",
  null
  
)

export default component.exports